import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const ViewDetailsApi = createAsyncThunk(
  'ViewDetails',
  async (viewDetailsPayload, { dispatch }) => {
    dispatch({ type: 'ViewDetails/pending', payload: {} });

    const {
      customerId,
      Authorization,
      customerRefNum,
      type,
      otpCode,
      templateType,
    } = viewDetailsPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'dashboardmenus/edit_profile/view_details',
      payload: {
        customerRefNum,
        profileDataModel: {
          type,
        },
        profileOtpReqModel: {
          otpCode,
          templateType,
        },
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({ type: 'ViewDetails/fulfilled', payload: res });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'ViewDetails/rejected', payload: err });
      },
    });
  }
);

export const ViewDetails_extrareducer = {
  [ViewDetailsApi.pending]: (state, action) => {
    state.viewDetailsApiState.isLoading = true;
  },
  [ViewDetailsApi.fulfilled]: (state, action) => {
    state.viewDetailsApiState.isLoading = false;
    state.viewDetailsApiState.isSuccess = true;
    state.viewDetailsApiState.isError = false;
    state.viewDetailsApiState.response = action.payload;
  },
  [ViewDetailsApi.rejected]: (state, action) => {
    state.viewDetailsApiState.isLoading = false;
    state.viewDetailsApiState.isSuccess = false;
    state.viewDetailsApiState.isError = true;
    state.viewDetailsApiState.response = action.payload;
  },
};
